import React, { useState, useEffect } from 'react';

import { ResetPassword, ForgotPassword, StepSuccess } from '../../molecules';
import { DefaultLayout } from '../../layouts';

import { default as t } from '../../../utils/i18n';

const Forgot = props => {
  const [forgotStep, setForgotStep] = useState(1);

  useEffect(() => {});

  return (
    <DefaultLayout>
      {forgotStep === 1 ? <ForgotPassword updateStep={setForgotStep} /> : null}
      {forgotStep === 2 ? <ResetPassword updateStep={setForgotStep} /> : null}
      {forgotStep === 3 ? (
        <StepSuccess
          heading={t('forgot.step3.heading')}
          subheading={t('forgot.step3.subheading')}
          buttonText={t('forgot.step3.buttonText')}
          navigationURL={'/signIn'}
        />
      ) : null}
    </DefaultLayout>
  );
};

export default Forgot;
